import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '../../front/Businesses/Card';
import Title from './Title';
import PlanList from './PlanList';
import { ServiceButton } from '../../core/Button';
import { BUSINESSES } from '../routing';
import { makeStyles } from '@material-ui/core/styles';
import T from 'i18n-react';
import Typography from '@material-ui/core/Typography';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& > *:not(:last-child)': {
      paddingBottom: theme.spacing(5),
    },
  },
  container: {
    margin: 'auto',
    width: '100%',
    maxWidth: theme.breakpoints.values.sm,
  },
  button: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  message: {
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
}));

const BusinessList = ({ businesses = [], plans = [], isAuthenticated }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Title text="OTETSUTABI LIST" dense>
        おてつたび先一覧
      </Title>
      <PlanList plans={plans} isAuthenticated={isAuthenticated} />
      <div>
        <Typography color="textPrimary" className={classes.title}>
          飛騨市のおてつたび先
        </Typography>
        <Typography className={classes.message}>
          {T.translate('homes.businessesText')}
        </Typography>
        <Grid container alignItems="center" spacing={2}>
          {businesses.map((business, idx) => (
            <Grid item xs={6} sm={4} md={3} lg={2} key={idx}>
              <Card isAuthenticated={isAuthenticated} {...business} />
            </Grid>
          ))}
        </Grid>
      </div>
      <div className={classes.container}>
        <ServiceButton
          variant="contained"
          color="primary"
          href={BUSINESSES + '?feature=hida'}
          className={classes.button}
        >
          飛騨市のおてつたび先一覧はこちら
        </ServiceButton>
      </div>
    </div>
  );
};

export default BusinessList;
